function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg/Svg";
var SpinnerSwap = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _objectSpread({
        viewBox: "0 0 100 100"
    }, props, {
        children: /*#__PURE__*/ _jsx("g", {
            className: "ldl-scale",
            style: {
                transformOrigin: "50% 50%",
                transform: "rotate(0deg) scale(0.8, 0.8)"
            },
            children: /*#__PURE__*/ _jsxs("g", {
                className: "ldl-ani",
                children: [
                    /*#__PURE__*/ _jsx("g", {
                        className: "ldl-layer",
                        children: /*#__PURE__*/ _jsx("g", {
                            className: "ldl-ani",
                            children: /*#__PURE__*/ _jsxs("g", {
                                children: [
                                    /*#__PURE__*/ _jsx("g", {
                                        className: "ldl-layer",
                                        children: /*#__PURE__*/ _jsx("g", {
                                            className: "ldl-ani",
                                            style: {
                                                transformOrigin: "50px 50px",
                                                opacity: 1,
                                                animation: "1.11111s linear -0.617284s infinite normal forwards running fade-spinner"
                                            },
                                            children: /*#__PURE__*/ _jsx("path", {
                                                strokeMiterlimit: "10",
                                                strokeLinejoin: "round",
                                                strokeLinecap: "round",
                                                strokeWidth: "6",
                                                stroke: "#849b87",
                                                fill: "none",
                                                d: "M61 35.333H42.667a7.333 7.333 0 0 0-7.333 7.333v0a7.333 7.333 0 0 0 7.333 7.333h14.667a7.333 7.333 0 0 1 7.333 7.333v0a7.333 7.333 0 0 1-7.333 7.333h-22",
                                                style: {
                                                    stroke: "rgb(255, 168, 38)"
                                                }
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("g", {
                                        className: "ldl-layer",
                                        children: /*#__PURE__*/ _jsx("g", {
                                            className: "ldl-ani",
                                            style: {
                                                transformOrigin: "50px 50px",
                                                opacity: 1,
                                                animation: "1.11111s linear -0.679012s infinite normal forwards running fade-spinner"
                                            },
                                            children: /*#__PURE__*/ _jsx("path", {
                                                d: "M50 64.667V70",
                                                strokeMiterlimit: "10",
                                                strokeLinejoin: "round",
                                                strokeLinecap: "round",
                                                strokeWidth: "6",
                                                stroke: "#849b87",
                                                fill: "none",
                                                style: {
                                                    stroke: "rgb(255, 168, 38)"
                                                }
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("g", {
                                        className: "ldl-layer",
                                        children: /*#__PURE__*/ _jsx("g", {
                                            className: "ldl-ani",
                                            style: {
                                                transformOrigin: "50px 50px",
                                                opacity: 1,
                                                animation: "1.11111s linear -0.740741s infinite normal forwards running fade-spinner"
                                            },
                                            children: /*#__PURE__*/ _jsx("path", {
                                                d: "M50 30v5.332",
                                                strokeMiterlimit: "10",
                                                strokeLinejoin: "round",
                                                strokeLinecap: "round",
                                                strokeWidth: "6",
                                                stroke: "#849b87",
                                                fill: "none",
                                                style: {
                                                    stroke: "rgb(255, 168, 38)"
                                                }
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("g", {
                        className: "ldl-layer",
                        children: /*#__PURE__*/ _jsx("g", {
                            className: "ldl-ani",
                            children: /*#__PURE__*/ _jsxs("g", {
                                children: [
                                    /*#__PURE__*/ _jsx("g", {
                                        className: "ldl-layer",
                                        children: /*#__PURE__*/ _jsx("g", {
                                            className: "ldl-ani",
                                            style: {
                                                transformOrigin: "50px 50px",
                                                opacity: 1,
                                                animation: "1.11111s linear -0.802469s infinite normal forwards running fade-spinner"
                                            },
                                            children: /*#__PURE__*/ _jsx("path", {
                                                strokeMiterlimit: "10",
                                                strokeLinejoin: "round",
                                                strokeLinecap: "round",
                                                strokeWidth: "6",
                                                stroke: "#76a4bd",
                                                fill: "none",
                                                d: "M50 85.609c19.666 0 35.609-15.943 35.609-35.609a35.47 35.47 0 0 0-8.199-22.733",
                                                style: {
                                                    stroke: "rgb(142, 9, 152)"
                                                }
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("g", {
                                        className: "ldl-layer",
                                        children: /*#__PURE__*/ _jsx("g", {
                                            className: "ldl-ani",
                                            style: {
                                                transformOrigin: "50px 50px",
                                                opacity: 1,
                                                animation: "1.11111s linear -0.864198s infinite normal forwards running fade-spinner"
                                            },
                                            children: /*#__PURE__*/ _jsx("path", {
                                                d: "M50 85.609L55.489 90",
                                                strokeMiterlimit: "10",
                                                strokeLinejoin: "round",
                                                strokeLinecap: "round",
                                                strokeWidth: "6",
                                                stroke: "#76a4bd",
                                                fill: "none",
                                                style: {
                                                    stroke: "rgb(142, 9, 152)"
                                                }
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("g", {
                                        className: "ldl-layer",
                                        children: /*#__PURE__*/ _jsx("g", {
                                            className: "ldl-ani",
                                            style: {
                                                transformOrigin: "50px 50px",
                                                opacity: 1,
                                                animation: "1.11111s linear -0.925926s infinite normal forwards running fade-spinner"
                                            },
                                            children: /*#__PURE__*/ _jsx("path", {
                                                d: "M50 85.609l4.391-5.489",
                                                strokeMiterlimit: "10",
                                                strokeLinejoin: "round",
                                                strokeLinecap: "round",
                                                strokeWidth: "6",
                                                stroke: "#76a4bd",
                                                fill: "none",
                                                style: {
                                                    stroke: "rgb(142, 9, 152)"
                                                }
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("g", {
                        className: "ldl-layer",
                        children: /*#__PURE__*/ _jsx("g", {
                            className: "ldl-ani",
                            children: /*#__PURE__*/ _jsxs("g", {
                                children: [
                                    /*#__PURE__*/ _jsx("g", {
                                        className: "ldl-layer",
                                        children: /*#__PURE__*/ _jsx("g", {
                                            className: "ldl-ani",
                                            style: {
                                                transformOrigin: "50px 50px",
                                                opacity: 1,
                                                animation: "1.11111s linear -0.987654s infinite normal forwards running fade-spinner"
                                            },
                                            children: /*#__PURE__*/ _jsx("path", {
                                                strokeMiterlimit: "10",
                                                strokeLinejoin: "round",
                                                strokeLinecap: "round",
                                                strokeWidth: "6",
                                                stroke: "#76a4bd",
                                                fill: "none",
                                                d: "M50 14.391c-19.666 0-35.609 15.943-35.609 35.609a35.47 35.47 0 0 0 8.199 22.733",
                                                style: {
                                                    stroke: "rgb(142, 9, 152)"
                                                }
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("g", {
                                        className: "ldl-layer",
                                        children: /*#__PURE__*/ _jsx("g", {
                                            className: "ldl-ani",
                                            style: {
                                                transformOrigin: "50px 50px",
                                                opacity: 1,
                                                animation: "1.11111s linear -1.04938s infinite normal forwards running fade-spinner"
                                            },
                                            children: /*#__PURE__*/ _jsx("path", {
                                                d: "M50 14.391L44.511 10",
                                                strokeMiterlimit: "10",
                                                strokeLinejoin: "round",
                                                strokeLinecap: "round",
                                                strokeWidth: "6",
                                                stroke: "#76a4bd",
                                                fill: "none",
                                                style: {
                                                    stroke: "rgb(142, 9, 152)"
                                                }
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("g", {
                                        className: "ldl-layer",
                                        children: /*#__PURE__*/ _jsx("g", {
                                            className: "ldl-ani",
                                            style: {
                                                transformOrigin: "50px 50px",
                                                opacity: 1,
                                                animation: "1.11111s linear -1.11111s infinite normal forwards running fade-spinner"
                                            },
                                            children: /*#__PURE__*/ _jsx("path", {
                                                d: "M50 14.391l-4.391 5.489",
                                                strokeMiterlimit: "10",
                                                strokeLinejoin: "round",
                                                strokeLinecap: "round",
                                                strokeWidth: "6",
                                                stroke: "#76a4bd",
                                                fill: "none",
                                                style: {
                                                    stroke: "rgb(142, 9, 152)"
                                                }
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    }));
};
export default SpinnerSwap;
